import {Injectable} from '@angular/core';
import {Effect, Actions} from '@ngrx/effects';
import * as freelancerAction from '../actions/freelancer.action';
import {map, switchMap, mergeMap} from 'rxjs/operators';
import {of} from 'rxjs/observable/of';
import {Action, Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';
import * as fromStore from '../../../store';
import {FreelancerService} from '../../freelancer.service';


@Injectable()
export class FreelancerEffect {
  constructor(private actions: Actions, private freelancerService: FreelancerService, private store: Store<fromStore.AppState>) {
  }

  @Effect()
  getAssignedFreelancers: Observable<Action> = this.actions.ofType(freelancerAction.GET_ASSIGNED_FREELANCERS)
    .map((action: freelancerAction.GetAssignedFreelancers) => action.payload)
    .pipe(
      mergeMap(body => {
        return this.freelancerService.getAssignedFreelancers(body)
          .map(res => new freelancerAction.GetAssignedFreelancersSuccess(res))
          .catch(error => of(new freelancerAction.GetAssignedFreelancersError(error)));
      })
  );

  @Effect()
  getFreelancer: Observable<Action> = this.actions.ofType(freelancerAction.GET_FREELANCER)
    .map((action: freelancerAction.GetFreelancer) => action.payload)
    .pipe(
      mergeMap(body => {
        return this.freelancerService.getFreelancers(body)
          .map(res => new freelancerAction.GetFreelancerSuccess(res))
          .catch(error => of(new freelancerAction.GetFreelancerError(error)));
      })
  );

  @Effect()
  getApprovedFreelancers: Observable<Action> = this.actions.ofType(freelancerAction.GET_APPROVED_FREELANCERS)
    .map((action: freelancerAction.GetApprovedFreelancers) => action.payload)
    .pipe(
      mergeMap(body => {
        return this.freelancerService.getApprovedFreelancers(body)
          .map(res => new freelancerAction.GetApprovedFreelancersSuccess(res))
          .catch(error => of(new freelancerAction.GetAssignedFreelancersError(error)));
      })
  );

  @Effect()
  updateApprovedFreelancer: Observable<Action> = this.actions.ofType(freelancerAction.UPDATE_ASSIGNED_FREELANCERS)
    .map((action: freelancerAction.UpdateAssignedFreelancers) => action.payload)
    .pipe(
      mergeMap(body => {
        return this.freelancerService.updateApprovedFreelancers(body)
          .map(res => new freelancerAction.UpdateAssignedFreelancersSuccess(res))
          .catch(error => of(new freelancerAction.UpdateAssignedFreelancersError(error)));
      })
  );

}



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/freelancers/store/effects/freelancer.effect.ts